import Container from "react-bootstrap/Container"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import Dropdown from "react-bootstrap/Dropdown"
import NavItem from "react-bootstrap/NavItem"
import NavLink from "react-bootstrap/NavLink"
import Row from "react-bootstrap/Row"

import { useTranslation } from "react-i18next";
import logo from "../img/BREIKKI_logo.svg"
import CuestickHamburger from "./CuestickHamburger"
import "../styles/App.css"
import "../styles/MainNavbar.css"
import loginService from "../services/loginService";
import { useNavigate } from "react-router-dom";
import { useState } from "react"



const MainNavbar = ({ changeLanguage, currentUser, setCurrentUser, isAdmin, isSuperuser }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [navbarOpen, setNavbarOpen] = useState(false)


  const handleLogoutClick = (e) => {
    e.preventDefault()
    loginService.postLogout()
      .then(res => {
        if (res.status === 200) {
          setCurrentUser(null)
          navigate("/")
          alert(t("logout_successful"))
        }
      }).catch(err => console.log(err))
  }


  return (
    <Row>
      <Container className="BREIKKI-main-navbar-container">
        <Navbar
          collapseOnSelect
          expand="xl"
          className="BREIKKI-main-navbar justify-content-space-between"
        >
          <Container>
            <Navbar.Brand href="/">
              <img
                src={logo}
                width="100"
                height="100"
                className="d-inline-block align-top BREIKKI-logo"
                alt=""
              />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setNavbarOpen(!navbarOpen)}>
              <CuestickHamburger open={navbarOpen} />
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
              {/* BREIKKI> dropdown */}
              {/* <Dropdown as={NavItem}>
                  <Dropdown.Toggle as={NavLink}><span className="BREIKKI-main-navbar-link-text">BREIKKI</span></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="/about-us">About Us</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              <Nav>
                <Nav.Link href="/about-us"><p className="BREIKKI-main-navbar-link-text">{t("about_us")}</p></Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link href="/feedback"><p className="BREIKKI-main-navbar-link-text">{t("feedback")}</p></Nav.Link>
              </Nav>
              <Nav>
                <Nav.Link href="/rules"><p className="BREIKKI-main-navbar-link-text">{t("rules")}</p></Nav.Link>
              </Nav>
              <Nav className="ms-auto">
                {/* Language select dropdown */}
                <Dropdown as={NavItem}>
                  <Dropdown.Toggle as={NavLink}><span className="BREIKKI-main-navbar-link-text">LANG</span></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => changeLanguage("fi")}>FI</Dropdown.Item>
                    <Dropdown.Divider />

                    <Dropdown.Item onClick={() => changeLanguage("en")}>EN</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {
                  isAdmin ?
                    (
                      <>
                        <Nav.Link href="/create-article"><p className="BREIKKI-main-navbar-link-text">{t("article_form_create_article_title")}</p></Nav.Link>
                        <Nav.Link href="/user-management"><p className="BREIKKI-main-navbar-link-text">{t("user_management_title")}</p></Nav.Link>
                        <Nav.Link><p className="BREIKKI-main-navbar-link-text">{currentUser.name}</p></Nav.Link>
                        <Nav.Link onClick={e => handleLogoutClick(e)}><p className="BREIKKI-main-navbar-link-text">{t("logout")}</p></Nav.Link>
                      </>
                    ) : (
                      <Nav.Link href="/login"><p className="BREIKKI-main-navbar-link-text">{t("login_title")}</p></Nav.Link>
                    )
                }
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </Container>
    </Row>
  )

}

export default MainNavbar